module.exports = __webpack_public_path__ + "media/sub5-4-4.20a38526.mp4";